// import React, { useEffect, useState } from "react";
// import axios from "axios";
// // import Constant from "../../utils/constant"; // Assuming you might use this later
// import { useNavigate } from "react-router-dom";

// // ✅ 1. DEFINE THE MODAL AS A SEPARATE COMPONENT
// // It receives `details` and `onClose` as props.
// // Helper function to convert number to words (Simplified for Indian numbering)
// const toWords = (num) => {
//   const a = [
//     "",
//     "one ",
//     "two ",
//     "three ",
//     "four ",
//     "five ",
//     "six ",
//     "seven ",
//     "eight ",
//     "nine ",
//     "ten ",
//     "eleven ",
//     "twelve ",
//     "thirteen ",
//     "fourteen ",
//     "fifteen ",
//     "sixteen ",
//     "seventeen ",
//     "eighteen ",
//     "nineteen ",
//   ];
//   const b = [
//     "",
//     "",
//     "twenty",
//     "thirty",
//     "forty",
//     "fifty",
//     "sixty",
//     "seventy",
//     "eighty",
//     "ninety",
//   ];

//   const number = parseFloat(num).toFixed(2).split(".");
//   const main = number[0];
//   const decimal = number[1];

//   if (main.length > 7) {
//     return "Number too large";
//   }

//   const nToWords = (n) => {
//     let str = "";
//     if (n > 19) {
//       str += b[Math.floor(n / 10)] + " " + a[n % 10];
//     } else {
//       str += a[n];
//     }
//     return str;
//   };

//   let str = "";
//   str +=
//     nToWords(Math.floor(main / 100000) % 100).length > 0
//       ? nToWords(Math.floor(main / 100000) % 100) + "lakh "
//       : "";
//   str +=
//     nToWords(Math.floor(main / 1000) % 100).length > 0
//       ? nToWords(Math.floor(main / 1000) % 100) + "thousand "
//       : "";
//   str +=
//     nToWords(Math.floor(main / 100) % 10).length > 0
//       ? nToWords(Math.floor(main / 100) % 10) + "hundred "
//       : "";
//   if (main > 100 && main % 100 > 0) {
//     str += "and ";
//   }
//   str += nToWords(main % 100);

//   let decimalPart = "";
//   if (decimal && parseInt(decimal) > 0) {
//     decimalPart = ` and ${nToWords(parseInt(decimal))} paise`;
//   }

//   return str.trim() === ""
//     ? "Zero"
//     : str.trim().replace(/\s+/g, " ") + decimalPart;
// };

// // ✅ REPLACED MODAL COMPONENT
// const PayslipModal = ({ details, employee, onClose }) => {
//   if (!details || !employee) {
//     return null;
//   }

//   // Format the month (e.g., "June, 2025")
//   const payslipMonth = new Date(details.month + "-02").toLocaleString(
//     "default",
//     { month: "long", year: "numeric" }
//   );
//   const doj = new Date(employee.joining_date).toLocaleDateString("en-GB");

//   const earnings = {
//     BASIC: parseFloat(details.base_salary) || 0,
//     "H.R.A.": parseFloat(details.hra) || 0,
//     "CONVEY.": parseFloat(details.conveyance) || 0,
//     "SPL.ALL": parseFloat(details.special_allowance) || 0,
//     MEDICAL: 0,
//     "ATT. ALL": 0,
//     "PERF.BON": 0,
//   };

//   const deductions = {
//     "E.P.F. (Employee's Share)": parseFloat(details.pf) || 0,
//     "E.S.I.C. (Employee's Share)": parseFloat(details.esi) || 0,
//     ADVANCE: 0,
//     TDS: 0,
//     LOAN: 0,
//     "P.TAX": 0,
//   };

//   const totalEarnings = Object.values(earnings).reduce(
//     (acc, val) => acc + val,
//     0
//   );
//   const totalDeductions = Object.values(deductions).reduce(
//     (acc, val) => acc + val,
//     0
//   );

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: "rgba(0, 0, 0, 0.7)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1050,
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: "white",
//           padding: "25px",
//           fontFamily: "Arial, sans-serif",
//           width: "800px",
//           border: "1px solid black",
//         }}
//       >
//         <div style={{ textAlign: "center", marginBottom: "20px" }}>
//           <h4 style={{ margin: "0", fontWeight: "bold" }}>
//             M/S POLICICUE INSURANCE BROKERS PRIVATE LIMITED
//           </h4>
//           <p style={{ margin: "0" }}>
//             A-42/6, Sector-62, Noida, Gautam Buddha Nagar, Uttar Pradesh-201301
//           </p>
//           <h5 style={{ margin: "10px 0 0 0", textDecoration: "underline" }}>
//             Salary Slip for the month of {payslipMonth}
//           </h5>
//         </div>

//         {/* Employee Details */}
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             border: "1px solid black",
//             fontSize: "14px",
//           }}
//         >
//           <tbody>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Employee Code
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.employee_id}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 P.F. Number
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.pf_number || "N/A"}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Employee Name
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {details.employee_name.toUpperCase()}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 PAN No.
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.pan_number || "N/A"}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 F/H Name
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.father_name || "N/A"}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Bank A/c No.
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.bank_account_number || "N/A"}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Designation
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.joining_position || "N/A"}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 ESI Number
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.esi_number || "N/A"}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Department
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.department}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 D.O.J.
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {doj}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Paid Days
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {details.work_days.toFixed(2)}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Leave
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {details.leave_days.toFixed(2)}
//               </td>
//             </tr>
//           </tbody>
//         </table>

//         {/* Earnings and Deductions */}
//         <div
//           style={{
//             display: "flex",
//             width: "100%",
//             border: "1px solid black",
//             borderTop: "none",
//           }}
//         >
//           <div style={{ width: "60%", borderRight: "1px solid black" }}>
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "14px",
//               }}
//             >
//               <thead>
//                 <tr style={{ backgroundColor: "#f2f2f2" }}>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                       borderLeft: "none",
//                     }}
//                   >
//                     Earnings
//                   </th>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                     }}
//                   >
//                     Rate
//                   </th>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                       borderRight: "none",
//                     }}
//                   >
//                     Earnings
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {Object.entries(earnings).map(([key, value]) => (
//                   <tr key={key}>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         borderLeft: "none",
//                       }}
//                     >
//                       {key}
//                     </td>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         textAlign: "right",
//                       }}
//                     >
//                       {value.toFixed(2)}
//                     </td>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         borderRight: "none",
//                         textAlign: "right",
//                       }}
//                     >
//                       {value.toFixed(2)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div style={{ width: "40%" }}>
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "14px",
//               }}
//             >
//               <thead>
//                 <tr style={{ backgroundColor: "#f2f2f2" }}>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                       borderLeft: "none",
//                     }}
//                   >
//                     Deductions
//                   </th>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                       borderRight: "none",
//                     }}
//                   >
//                     Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {Object.entries(deductions).map(([key, value]) => (
//                   <tr key={key}>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         borderLeft: "none",
//                       }}
//                     >
//                       {key}
//                     </td>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         borderRight: "none",
//                         textAlign: "right",
//                       }}
//                     >
//                       {value.toFixed(2)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Totals */}
//         <div
//           style={{
//             display: "flex",
//             width: "100%",
//             border: "1px solid black",
//             borderTop: "none",
//             fontSize: "14px",
//             fontWeight: "bold",
//           }}
//         >
//           <div
//             style={{
//               width: "60%",
//               display: "flex",
//               borderRight: "1px solid black",
//             }}
//           >
//             <div
//               style={{
//                 width: "33.33%",
//                 padding: "4px",
//                 borderRight: "1px solid black",
//               }}
//             >
//               Total
//             </div>
//             <div
//               style={{
//                 width: "33.33%",
//                 padding: "4px",
//                 textAlign: "right",
//                 borderRight: "1px solid black",
//               }}
//             >
//               {totalEarnings.toFixed(2)}
//             </div>
//             <div
//               style={{ width: "33.33%", padding: "4px", textAlign: "right" }}
//             >
//               {totalEarnings.toFixed(2)}
//             </div>
//           </div>
//           <div style={{ width: "40%", display: "flex" }}>
//             <div
//               style={{
//                 width: "50%",
//                 padding: "4px",
//                 borderRight: "1px solid black",
//               }}
//             >
//               Total
//             </div>
//             <div style={{ width: "50%", padding: "4px", textAlign: "right" }}>
//               {totalDeductions.toFixed(2)}
//             </div>
//           </div>
//         </div>

//         {/* Net Payable */}
//         <div
//           style={{
//             display: "flex",
//             width: "100%",
//             border: "1px solid black",
//             borderTop: "none",
//             fontSize: "14px",
//             fontWeight: "bold",
//           }}
//         >
//           <div style={{ width: "60%", padding: "4px" }}>
//             Net Payable for the Month {payslipMonth}
//           </div>
//           <div style={{ width: "40%", padding: "4px", textAlign: "right" }}>
//             {details.net_pay}
//           </div>
//         </div>

//         {/* In Words */}
//         <div
//           style={{
//             width: "100%",
//             padding: "8px 4px",
//             border: "1px solid black",
//             borderTop: "none",
//             fontSize: "14px",
//           }}
//         >
//           (Rupees {toWords(details.net_pay)} Only )
//         </div>

//         {/* Footer */}
//         <div
//           style={{
//             width: "100%",
//             padding: "8px 4px",
//             border: "1px solid black",
//             borderTop: "none",
//             fontSize: "12px",
//           }}
//         >
//           Note: This is computer generated statement and does not require
//           signature
//         </div>

//         {/* Close Button */}
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <button className="btn btn-danger" onClick={onClose}>
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default function Payroll() {
//   const [payrollData, setPayrollData] = useState([]);
//   // Inside your Payroll component
//   const [employeeDetailsForModal, setEmployeeDetailsForModal] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [salaryMonth, setSalaryMonth] = useState("");
//   const history = useNavigate();
//   const [selectedMonth, setSelectedMonth] = useState("");

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [payslipDetails, setPayslipDetails] = useState(null);

//   const fetchPayrollData = async (page) => {
//     setLoading(true);
//     try {
//       const response = await axios.post(
//         // Using GET as it's more appropriate for fetching a list
//         // `http://localhost:1051/hrms/getEmployeeList?page=${page}&limit=${itemsPerPage}`
//         `https://api.policicue.com/hrms/getEmployeeList?page=${page}&limit=${itemsPerPage}`
//       );
//       setPayrollData(response.data.data || []);
//     } catch (error) {
//       console.error("Error fetching payroll data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayrollData(currentPage);
//   }, [currentPage]);

//   const handleCalculateSalary = async () => {
//     if (!salaryMonth) {
//       alert("Please select a month to calculate the salary.");
//       return;
//     }
//     try {
//       const response = await axios.post(
//         // "http://localhost:1051/hrms/calculatePayrollForAll",
//         "https://api.policicue.com/hrms/calculatePayrollForAll",
//         { month: salaryMonth }
//       );

//       if (response.data && response.data.status === 1) {
//         const { successCount, failedCount, failedEmployees, message } =
//           response.data;
//         let alertMessage = `${message}\nSuccess: ${successCount}\nFailed: ${failedCount}`;

//         if (failedCount > 0) {
//           alertMessage +=
//             "\nCheck the console for details on failed employees.";
//           console.error("Failed Employee Calculations:", failedEmployees);
//         }
//         alert(alertMessage);
//       } else {
//         alert(
//           response.data.message || "Salary calculation initiated successfully!"
//         );
//       }
//     } catch (error) {
//       console.error("Error calculating salary:", error.response?.data || error);
//       alert(
//         error.response?.data?.message ||
//           "Salary calculation failed. Please try again."
//       );
//     }
//   };

//   const handleNextPage = () => {
//     setCurrentPage((prev) => prev + 1);
//   };
//   // Inside your Payroll component, modify this function
//   // Inside your Payroll component, modify this function
//   const handleViewPayslip = async (employeeId, month, employeeData) => {
//     // Added employeeData
//     if (!month) {
//       alert("Please select a month first");
//       return;
//     }
//     try {
//       const response = await axios.get(
//         // `http://localhost:1051/hrms/viewPayslip`,
//         `https://api.policicue.com/hrms/viewPayslip`,
//         {
//           params: { employee_id: employeeId, month: month },
//         }
//       );

//       if (response.data.status === 1) {
//         setPayslipDetails(response.data.data);
//         setEmployeeDetailsForModal(employeeData); // <-- Store employee data
//         setIsModalOpen(true);
//       } else {
//         alert(
//           response.data.message || "Could not find payslip for this month."
//         );
//       }
//     } catch (error) {
//       console.error("View Payslip error:", error);
//       alert("Failed to fetch payslip details.");
//     }
//   };
//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage((prev) => prev - 1);
//     }
//   };

//   const handleDownloadPayslip = async (employeeId, month) => {
//     if (!month) {
//       alert("Please select a month first");
//       return;
//     }
//     try {
//       const response = await axios.get(
//         // `http://localhost:1051/hrms/downloadPayslip`,
//         `https://api.policicue.com/hrms/downloadPayslip`,
//         {
//           params: { employee_id: employeeId, month: month },
//           responseType: "blob",
//         }
//       );

//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Payslip_${employeeId}_${month}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Download error:", error);
//       alert(
//         "Failed to download payslip. It may not exist for the selected month."
//       );
//     }
//   };

//   return (
//     <div className="Payroll">
//       {/* ✅ 2. RENDER THE MODAL COMPONENT CONDITIONALLY */}
//       {/* It will only appear when isModalOpen is true */}
//       {isModalOpen && (
//         <PayslipModal
//           details={payslipDetails}
//           employee={employeeDetailsForModal} // ✅ pass employee data
//           onClose={() => setIsModalOpen(false)}
//         />
//       )}

//       <div className="container-fluid my-2">
//         <div className="row">
//           <main className="mainBodyContainer">
//             {/* The rest of your JSX remains here... */}
//             <div className="row my-2">
//               <div className="col-10 py-2 px-3">
//                 <h4
//                   className="text-capitalize"
//                   style={{
//                     fontFamily: "ErasDemiITC",
//                     fontWeight: "bold",
//                     marginTop: "1rem",
//                     marginLeft: "12px",
//                   }}
//                 >
//                   Payroll
//                 </h4>
//               </div>
//               <div className="col-3 form-group" style={{ float: "right" }}>
//                 <label>Select Month to Calculate Salary:</label>
//                 <div className="d-flex align-items-center gap-2">
//                   <input
//                     type="month"
//                     className="form-control"
//                     value={salaryMonth}
//                     onChange={(e) => setSalaryMonth(e.target.value)}
//                   />
//                   <button
//                     className="btn btn-success"
//                     style={{ whiteSpace: "nowrap" }}
//                     onClick={handleCalculateSalary}
//                   >
//                     Calculate Salary
//                   </button>
//                 </div>
//               </div>
//               <div className="col-lg-3 col-md-4">
//                 <label className="form-label">
//                   {" "}
//                   Select Month to View Payslip:
//                 </label>
//                 <input
//                   type="month"
//                   className="form-control"
//                   value={selectedMonth}
//                   onChange={(e) => setSelectedMonth(e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="row my-2">
//               <div className="col-12 py-1 px-3">
//                 <div className="bg-white p-2 rounded-3 shadow-sm">
//                   {loading ? (
//                     <p>Loading...</p>
//                   ) : (
//                     <>
//                       <table className="table table-striped table-hover">
//                         <thead>
//                           <tr
//                             className="text-uppercase"
//                             style={{
//                               lineHeight: "15px",
//                               fontFamily: "Calibri",
//                               fontSize: "14px",
//                               color: "#7D90B2",
//                               backgroundColor: "#F4F7FC",
//                             }}
//                           >
//                             <th className="py-3">Employee</th>
//                             <th className="text-center py-3">Joining Date</th>
//                             <th className="text-center py-3">Department</th>
//                             <th className="text-center py-3">Salary</th>
//                             <th className="text-center py-3">Actions</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {payrollData.map((employee, index) => {
//                             const emp = employee.employeeData || {};
//                             return (
//                               <tr key={emp.id || index}>
//                                 <td>
//                                   <div>
//                                     {`${emp.first_name} ${emp.last_name}` ||
//                                       "--"}
//                                     <br />
//                                     <span
//                                       style={{
//                                         fontSize: "12px",
//                                         color: "#7D90B2",
//                                       }}
//                                     >
//                                       Emp ID: {emp.employee_id || "--"}
//                                     </span>
//                                   </div>
//                                 </td>
//                                 <td className="text-center">
//                                   {new Date(
//                                     emp.joining_date
//                                   ).toLocaleDateString()}
//                                 </td>
//                                 <td className="text-center">
//                                   {emp.department || "--"}
//                                 </td>
//                                 <td className="text-center">
//                                   ₹{emp.inhand_salary || "0"}
//                                 </td>

//                                 <td className="text-center">
//                                   <i
//                                     className="bi bi-box-arrow-down"
//                                     style={{
//                                       cursor: "pointer",
//                                       color: "#007bff",
//                                       paddingLeft: "20px",
//                                       fontSize: "1.2rem",
//                                     }}
//                                     title="Download Payslip"
//                                     onClick={() =>
//                                       handleDownloadPayslip(
//                                         emp.employee_id,
//                                         selectedMonth
//                                       )
//                                     }
//                                   ></i>
//                                   <i
//                                     className="bi bi-eye"
//                                     style={{
//                                       cursor: "pointer",
//                                       color: "#17a2b8",
//                                       paddingLeft: "20px",
//                                       fontSize: "1.2rem",
//                                     }}
//                                     title="View Payslip"
//                                     onClick={() =>
//                                       handleViewPayslip(
//                                         emp.employee_id,
//                                         selectedMonth,
//                                         emp
//                                       )
//                                     }
//                                   ></i>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>

//                       <div className="d-flex justify-content-between align-items-center mt-3 px-2">
//                         <button
//                           className="btn btn-outline-primary btn-sm"
//                           onClick={handlePreviousPage}
//                           disabled={currentPage === 1}
//                         >
//                           Previous
//                         </button>
//                         <span>Page {currentPage}</span>
//                         <button
//                           className="btn btn-outline-primary btn-sm"
//                           onClick={handleNextPage}
//                           disabled={payrollData.length < itemsPerPage}
//                         >
//                           Next
//                         </button>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </main>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import axios from "axios";
// import Constant from "../../utils/constant"; // Assuming you might use this later
import { useNavigate } from "react-router-dom";

// ✅ 1. DEFINE THE MODAL AS A SEPARATE COMPONENT
// It receives `details` and `onClose` as props.
// Helper function to convert number to words (Simplified for Indian numbering)
const toWords = (num) => {
  const a = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "eleven ",
    "twelve ",
    "thirteen ",
    "fourteen ",
    "fifteen ",
    "sixteen ",
    "seventeen ",
    "eighteen ",
    "nineteen ",
  ];
  const b = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  const number = parseFloat(num).toFixed(2).split(".");
  const main = number[0];
  const decimal = number[1];

  if (main.length > 7) {
    return "Number too large";
  }

  const nToWords = (n) => {
    let str = "";
    if (n > 19) {
      str += b[Math.floor(n / 10)] + " " + a[n % 10];
    } else {
      str += a[n];
    }
    return str;
  };

  let str = "";
  str +=
    nToWords(Math.floor(main / 100000) % 100).length > 0
      ? nToWords(Math.floor(main / 100000) % 100) + "lakh "
      : "";
  str +=
    nToWords(Math.floor(main / 1000) % 100).length > 0
      ? nToWords(Math.floor(main / 1000) % 100) + "thousand "
      : "";
  str +=
    nToWords(Math.floor(main / 100) % 10).length > 0
      ? nToWords(Math.floor(main / 100) % 10) + "hundred "
      : "";
  if (main > 100 && main % 100 > 0) {
    str += "and ";
  }
  str += nToWords(main % 100);

  let decimalPart = "";
  if (decimal && parseInt(decimal) > 0) {
    decimalPart = ` and ${nToWords(parseInt(decimal))} paise`;
  }

  return str.trim() === ""
    ? "Zero"
    : str.trim().replace(/\s+/g, " ") + decimalPart;
};

// ✅ REPLACED MODAL COMPONENT
// ✅ REPLACED MODAL COMPONENT
const PayslipModal = ({ details, employee, onClose }) => {
  if (!details || !employee) {
    return null;
  }

  // ✅ 1. CALCULATE LEAVE DEDUCTION ON THE FRONTEND
  // Parse the required values from the API response
  const baseSalary = parseFloat(details.base_salary) || 0;
  const hra = parseFloat(details.hra) || 0;
  const conveyance = parseFloat(details.conveyance) || 0;
  const specialAllowance = parseFloat(details.special_allowance) || 0;
  const unpaidLeaveDays = parseFloat(details.unpaid_leave_days) || 0;

  // Calculate the full monthly gross salary (before any leave deduction)
  const fullGrossSalary = baseSalary + hra + conveyance + specialAllowance;

  // Calculate the deduction amount based on your formula
  const perDaySalary = fullGrossSalary / 30; // Assuming 30 days in a month for calculation
  const leaveDeductionAmount = perDaySalary * unpaidLeaveDays;

  // Format the month (e.g., "June, 2025")
  const payslipMonth = new Date(details.month + "-02").toLocaleString(
    "default",
    { month: "long", year: "numeric" }
  );
  const doj = new Date(employee.joining_date).toLocaleDateString("en-GB");

  const earnings = {
    BASIC: baseSalary,
    "H.R.A.": hra,
    "CONVEY.": conveyance,
    "SPL.ALL": specialAllowance,
    MEDICAL: 0,
    "ATT. ALL": 0,
    "PERF.BON": 0,
  };

  // ✅ 2. ADD THE CALCULATED LEAVE DEDUCTION TO THE DEDUCTIONS OBJECT
  const deductions = {
    "E.P.F. (Employee's Share)": parseFloat(details.pf) || 0,
    "E.S.I.C. (Employee's Share)": parseFloat(details.esi) || 0,
    ADVANCE: 0,
    TDS: 0,
    LOAN: 0,
    "P.TAX": 0,
    "LEAVE DEDUCTION": leaveDeductionAmount, // Use the calculated value here
  };

  // The total earnings should reflect the full salary before deductions
  const totalEarnings = Object.values(earnings).reduce(
    (acc, val) => acc + val,
    0
  );

  const totalDeductions = Object.values(deductions).reduce(
    (acc, val) => acc + val,
    0
  );

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "25px",
          fontFamily: "Arial, sans-serif",
          width: "800px",
          border: "1px solid black",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h4 style={{ margin: "0", fontWeight: "bold" }}>
            M/S POLICICUE INSURANCE BROKERS PRIVATE LIMITED
          </h4>
          <p style={{ margin: "0" }}>
            A-42/6, Sector-62, Noida, Gautam Buddha Nagar, Uttar Pradesh-201301
          </p>
          <h5 style={{ margin: "10px 0 0 0", textDecoration: "underline" }}>
            Salary Slip for the month of {payslipMonth}
          </h5>
        </div>

        {/* Employee Details */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid black",
            fontSize: "14px",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Employee Code
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.employee_id}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                P.F. Number
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.pf_number || "N/A"}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Employee Name
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {details.employee_name.toUpperCase()}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                PAN No.
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.pan_number || "N/A"}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                F/H Name
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.father_name || "N/A"}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Bank A/c No.
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.bank_account_number || "N/A"}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Designation
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.joining_position || "N/A"}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                ESI Number
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.esi_number || "N/A"}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Department
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.department}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                D.O.J.
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {doj}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Paid Days
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {details.work_days.toFixed(2)}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Leave
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {details.leave_days.toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Earnings and Deductions */}
        <div
          style={{
            display: "flex",
            width: "100%",
            border: "1px solid black",
            borderTop: "none",
          }}
        >
          <div style={{ width: "60%", borderRight: "1px solid black" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                      borderLeft: "none",
                    }}
                  >
                    Earnings
                  </th>
                  {/* <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                    }}
                  >
                    Rate
                  </th> */}
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                      borderRight: "none",
                    }}
                  >
                    Earnings
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(earnings).map(([key, value]) => (
                  <tr key={key}>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        borderLeft: "none",
                      }}
                    >
                      {key}
                    </td>
                    {/* <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        textAlign: "right",
                      }}
                    >
                      {value.toFixed(2)}
                    </td> */}
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        borderRight: "none",
                        textAlign: "right",
                      }}
                    >
                      {value.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ width: "40%" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                      borderLeft: "none",
                    }}
                  >
                    Deductions
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                      borderRight: "none",
                    }}
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(deductions).map(([key, value]) => (
                  <tr key={key}>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        borderLeft: "none",
                      }}
                    >
                      {key}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        borderRight: "none",
                        textAlign: "right",
                      }}
                    >
                      {value.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Totals */}
        <div
          style={{
            display: "flex",
            width: "100%",
            border: "1px solid black",
            borderTop: "none",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          <div
            style={{
              width: "60%",
              display: "flex",
              borderRight: "1px solid black",
            }}
          >
            <div
              style={{
                width: "33.33%",
                padding: "4px",
                borderRight: "1px solid black",
              }}
            >
              Total
            </div>
            {/* <div
              style={{
                width: "33.33%",
                padding: "4px",
                textAlign: "right",
                borderRight: "1px solid black",
              }}
            >
              {totalEarnings.toFixed(2)}
            </div> */}
            <div
              style={{ width: "33.33%", padding: "4px", textAlign: "right" }}
            >
              {totalEarnings.toFixed(2)}
            </div>
          </div>
          <div style={{ width: "40%", display: "flex" }}>
            <div
              style={{
                width: "50%",
                padding: "4px",
                borderRight: "1px solid black",
              }}
            >
              Total
            </div>
            <div style={{ width: "50%", padding: "4px", textAlign: "right" }}>
              {totalDeductions.toFixed(2)}
            </div>
          </div>
        </div>

        {/* Net Payable */}
        <div
          style={{
            display: "flex",
            width: "100%",
            border: "1px solid black",
            borderTop: "none",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          <div style={{ width: "60%", padding: "4px" }}>
            Net Payable for the Month {payslipMonth}
          </div>
          <div style={{ width: "40%", padding: "4px", textAlign: "right" }}>
            {details.net_pay}
          </div>
        </div>

        {/* In Words */}
        <div
          style={{
            width: "100%",
            padding: "8px 4px",
            border: "1px solid black",
            borderTop: "none",
            fontSize: "14px",
          }}
        >
          (Rupees {toWords(details.net_pay)} Only )
        </div>

        {/* Footer */}
        <div
          style={{
            width: "100%",
            padding: "8px 4px",
            border: "1px solid black",
            borderTop: "none",
            fontSize: "12px",
          }}
        >
          Note: This is computer generated statement and does not require
          signature
        </div>

        {/* Close Button */}
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button className="btn btn-danger" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default function Payroll() {
  const [payrollData, setPayrollData] = useState([]);
  // Inside your Payroll component
  const [employeeDetailsForModal, setEmployeeDetailsForModal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [salaryMonth, setSalaryMonth] = useState("");
  const history = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [payslipDetails, setPayslipDetails] = useState(null);

  const fetchPayrollData = async (page) => {
    setLoading(true);
    try {
      const response = await axios.post(
        // Using GET as it's more appropriate for fetching a list
        // `http://localhost:1051/hrms/getEmployeeList?page=${page}&limit=${itemsPerPage}`
        `https://api.policicue.com/hrms/getEmployeeList?page=${page}&limit=${itemsPerPage}`
      );
      setPayrollData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching payroll data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayrollData(currentPage);
  }, [currentPage]);

  const handleCalculateSalary = async () => {
    if (!salaryMonth) {
      alert("Please select a month to calculate the salary.");
      return;
    }
    try {
      const response = await axios.post(
        // "http://localhost:1051/hrms/calculatePayrollForAll",
        "https://api.policicue.com/hrms/calculatePayrollForAll",
        { month: salaryMonth }
      );

      if (response.data && response.data.status === 1) {
        const { successCount, failedCount, failedEmployees, message } =
          response.data;
        let alertMessage = `${message}\nSuccess: ${successCount}\nFailed: ${failedCount}`;

        if (failedCount > 0) {
          alertMessage +=
            "\nCheck the console for details on failed employees.";
          console.error("Failed Employee Calculations:", failedEmployees);
        }
        alert(alertMessage);
      } else {
        alert(
          response.data.message || "Salary calculation initiated successfully!"
        );
      }
    } catch (error) {
      console.error("Error calculating salary:", error.response?.data || error);
      alert(
        error.response?.data?.message ||
          "Salary calculation failed. Please try again."
      );
    }
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };
  // Inside your Payroll component, modify this function
  // Inside your Payroll component, modify this function
  const handleViewPayslip = async (employeeId, month, employeeData) => {
    // Added employeeData
    if (!month) {
      alert("Please select a month first");
      return;
    }
    try {
      const response = await axios.get(
        // `http://localhost:1051/hrms/viewPayslip`,
        `https://api.policicue.com/hrms/viewPayslip`,
        {
          params: { employee_id: employeeId, month: month },
        }
      );

      if (response.data.status === 1) {
        setPayslipDetails(response.data.data);
        setEmployeeDetailsForModal(employeeData); // <-- Store employee data
        setIsModalOpen(true);
      } else {
        alert(
          response.data.message || "Could not find payslip for this month."
        );
      }
    } catch (error) {
      console.error("View Payslip error:", error);
      alert("Failed to fetch payslip details.");
    }
  };
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleDownloadPayslip = async (employeeId, month) => {
    if (!month) {
      alert("Please select a month first");
      return;
    }
    try {
      const response = await axios.get(
        // `http://localhost:1051/hrms/downloadPayslip`,
        `https://api.policicue.com/hrms/downloadPayslip`,
        {
          params: { employee_id: employeeId, month: month },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Payslip_${employeeId}_${month}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert(
        "Failed to download payslip. It may not exist for the selected month."
      );
    }
  };

  return (
    <div className="Payroll">
      {/* ✅ 2. RENDER THE MODAL COMPONENT CONDITIONALLY */}
      {/* It will only appear when isModalOpen is true */}
      {isModalOpen && (
        <PayslipModal
          details={payslipDetails}
          employee={employeeDetailsForModal} // ✅ pass employee data
          onClose={() => setIsModalOpen(false)}
        />
      )}

      <div className="container-fluid my-2">
        <div className="row">
          <main className="mainBodyContainer">
            {/* The rest of your JSX remains here... */}
            <div className="row my-2">
              {/* <div className="col-10 py-2 px-3"> */}
              <div className="col">
                <h4
                  className="text-capitalize"
                  style={{
                    fontFamily: "ErasDemiITC",
                    fontWeight: "bold",
                    marginTop: "1rem",
                    marginLeft: "12px",
                  }}
                >
                  Payroll
                </h4>
              </div>
              {/* <div className="col-3 form-group"> */}
              <div className="col-auto">
                <label>Select Month to Calculate Salary:</label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="month"
                    className="form-control"
                    value={salaryMonth}
                    onChange={(e) => setSalaryMonth(e.target.value)}
                  />
                  <button
                    className="btn btn-success"
                    style={{ whiteSpace: "nowrap" }}
                    onClick={handleCalculateSalary}
                  >
                    Calculate Salary
                  </button>
                </div>
              </div>
              {/* <div className="col-lg-3 col-md-4" style={{ float: "right" }}> */}
              <div className="col-auto">
                <label className="form-label">
                  {" "}
                  Select Month to View Payslip:
                </label>
                <input
                  type="month"
                  className="form-control"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                />
              </div>
            </div>
            <div className="row my-2">
              <div className="col-12 py-1 px-3">
                <div className="bg-white p-2 rounded-3 shadow-sm">
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <>
                      <table className="table table-striped table-hover">
                        <thead>
                          <tr
                            className="text-uppercase"
                            style={{
                              lineHeight: "15px",
                              fontFamily: "Calibri",
                              fontSize: "14px",
                              color: "#7D90B2",
                              backgroundColor: "#F4F7FC",
                            }}
                          >
                            <th className="py-3">Employee</th>
                            <th className="text-center py-3">Joining Date</th>
                            <th className="text-center py-3">Department</th>
                            <th className="text-center py-3">Salary</th>
                            <th className="text-center py-3">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {payrollData.map((employee, index) => {
                            const emp = employee.employeeData || {};
                            return (
                              <tr key={emp.id || index}>
                                <td>
                                  <div>
                                    {`${emp.first_name} ${emp.last_name}` ||
                                      "--"}
                                    <br />
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        color: "#7D90B2",
                                      }}
                                    >
                                      Emp ID: {emp.employee_id || "--"}
                                    </span>
                                  </div>
                                </td>
                                <td className="text-center">
                                  {new Date(
                                    emp.joining_date
                                  ).toLocaleDateString()}
                                </td>
                                <td className="text-center">
                                  {emp.department || "--"}
                                </td>
                                <td className="text-center">
                                  ₹{emp.inhand_salary || "0"}
                                </td>

                                <td className="text-center">
                                  <i
                                    className="bi bi-box-arrow-down"
                                    style={{
                                      cursor: "pointer",
                                      color: "#007bff",
                                      paddingLeft: "20px",
                                      fontSize: "1.2rem",
                                    }}
                                    title="Download Payslip"
                                    onClick={() =>
                                      handleDownloadPayslip(
                                        emp.employee_id,
                                        selectedMonth
                                      )
                                    }
                                  ></i>
                                  <i
                                    className="bi bi-eye"
                                    style={{
                                      cursor: "pointer",
                                      color: "#17a2b8",
                                      paddingLeft: "20px",
                                      fontSize: "1.2rem",
                                    }}
                                    title="View Payslip"
                                    onClick={() =>
                                      handleViewPayslip(
                                        emp.employee_id,
                                        selectedMonth,
                                        emp
                                      )
                                    }
                                  ></i>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>

                      <div className="d-flex justify-content-between align-items-center mt-3 px-2">
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                        <span>Page {currentPage}</span>
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={handleNextPage}
                          disabled={payrollData.length < itemsPerPage}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
